import React from 'react';
import Noticias from './Noticias';

function App() {
  return (
    <div className="App">
      <Noticias />
    </div>
  );
}

export default App;
